module.exports = __webpack_public_path__ + "img/icon_white-big_car.7e53c93f.svg";